import React from "react";
import SharedDonut from "../../common/DonutChart";
import { BRAND, getPaletteColor } from "../../../utils/chartTheme";

const CommunityFeedbackWidget = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full">
        <div className="animate-pulse h-full flex flex-col justify-center">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4 mx-auto"></div>
          <div className="space-y-3">
            <div className="h-4 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="bg-white h-full flex items-center justify-center">
        <div className="text-center py-8 text-gray-500">
          No community feedback data available
        </div>
      </div>
    );
  }

  const {
    communitySatisfaction = {},
    totalFeedbacks = 0,
    averageSatisfactionScore = 0,
  } = data;

  const satisfactionData = [
    {
      level: "Satisfied",
      count: communitySatisfaction["Satisfied"]?.count || 0,
      percentage: parseFloat(
        communitySatisfaction["Satisfied"]?.percentage || "0"
      ),
      color: BRAND.teal, 
    },
    {
      level: "Neutral",
      count: communitySatisfaction["Neutral"]?.count || 0,
      percentage: parseFloat(
        communitySatisfaction["Neutral"]?.percentage || "0"
      ),
      color: getPaletteColor(5), 
    },
    {
      level: "Dissatisfied",
      count: communitySatisfaction["Dissatisfied"]?.count || 0,
      percentage: parseFloat(
        communitySatisfaction["Dissatisfied"]?.percentage || "0"
      ),
      color: getPaletteColor(4), 
    },
  ];

  return (
    <div className="bg-white h-full flex flex-col">
      <h3 className="text-lg text-[#3A3A3A] font-bold uppercase text-center pt-3 text-balance">
        Community Feedback
      </h3>
      <SharedDonut
        items={satisfactionData.map((item) => ({
          name: item.level,
          value: item.count,
          color: item.color,
        }))}
        centerValue={totalFeedbacks || undefined}
      />
    </div>
  );
};

export default CommunityFeedbackWidget;
